import { FC } from 'react';
import ReadonlyView from '@/components/form/readonly-view';
import { ReadonlyField } from '@/components/form/readonly-view/helpers';
import { Stack } from '@mui/material';
import { McpServerModel } from '@/lib/models/mcp-server.model';
import { startCase, upperCase } from 'lodash';
import Chip from '@/components/chip';
import NoneChip from '@/components/chip/none-chip';
import ExternalLink from '@/components/external-link';

interface Props {
  data: McpServerModel;
}

const getReadonlyFields = (): ReadonlyField[] => {
  return [
    { label: 'Name', prop: 'name' },
    { label: 'Description', prop: 'description' },
    { label: 'Type', prop: 'type' },
    { label: 'Category', prop: 'category' },
    { label: 'Tags', prop: 'tags' },
    { label: 'Project URL', prop: 'project' },
  ];
};

const getReadonlyData = (data: McpServerModel | null) => {
  if (!data) {
    return {};
  }

  const { name, description, type, category, tags, source } = data;
  const hasTags = !!tags.length;

  const { project } = source;

  return {
    name,
    type: upperCase(type),
    description,
    category: startCase(category),
    tags: hasTags ? (
      <Stack direction="row" gap={0.5} flexWrap="wrap">
        {tags.map((tag) => (
          <Chip key={tag} label={tag} size="small" />
        ))}
      </Stack>
    ) : (
      <NoneChip />
    ),
    project: project ? (
      <ExternalLink withIcon label={project} href={project} />
    ) : (
      <NoneChip notAvailable />
    ),
  };
};

export const Details: FC<Props> = ({ data }) => {
  return <ReadonlyView fields={getReadonlyFields()} data={getReadonlyData(data)} />;
};

export default Details;
